import {WlFavorite} from "./favorite.component";
import {defineWebComponent} from "../webcomponents-utils";

export * from './favorite.component';
export default WlFavorite;

defineWebComponent('wl-favorite', WlFavorite);
